import { render, staticRenderFns } from "./CustomerServicesCharge.vue?vue&type=template&id=70b6e184"
import script from "./CustomerServicesCharge.vue?vue&type=script&lang=js"
export * from "./CustomerServicesCharge.vue?vue&type=script&lang=js"
import style0 from "./CustomerServicesCharge.vue?vue&type=style&index=0&id=70b6e184&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports